const customCSS = `
  
`;
const customInjectedCSS = `

  `;

function injectCSS() {
  const host = document.querySelector("#retorik-shadow");
  if (host && host.shadowRoot && customInjectedCSS) {
    // Inject shadow dom custom CSS
    console.log("styleToInject in Shadow", customInjectedCSS);
    const injectedStyle = document.createElement("style");
    injectedStyle.innerHTML = customInjectedCSS;
    if (host && host.shadowRoot) host.shadowRoot.appendChild(injectedStyle);
  }

  console.log("styleToInject", customCSS);
  const style = document.createElement("style");
  style.innerHTML = customCSS;
  document.body.appendChild(style);
}

const botEventHandler = (action: any) => {
  if (action) {
    console.log("action", action);
  }

  if (action && action.type === "DIRECT_LINE/CONNECT_FULFILLED") {
    injectCSS();
  }
  return false;
};

export { botEventHandler };
